module.exports = __webpack_public_path__ + "img/icon_back.f4177d34.svg";